module.exports = __webpack_public_path__ + "img/thumb_GiftCard.ddac98b9.png";